/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/drop-menu/drop-menu');
require('components/base/checkbox/checkbox');
require('components/base/btn/btn');
require('components/base/form-area/form-area');
require('components/base/pop/pop');
require('components/base/upload/upload')
require('components/common/drop-menu-input/drop-menu-input')
require('./server-set.scss');

const template = require('./server-set.tpl');
const store = require('appVuex/store');
const ajax = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');


const serverSet = {
	name: "serverSet",

	template,

	data() {
    return {
      linkData: [
        {
          value: 1,
          text: "app内连接"
        },
        {
          value: 2,
          text: "外部连接"
        }
      ],
      official: false,
      maxServerNum: 1,
      serverNumList: [],
      uploadImg: apiPath.common.uploadImg,
      params:{
        serviceId: "",
        serverName: "",
        linkType: 1,
        link: "",
        platform: 1,
        user: 1,
        newFlag: -1,
        sort: 1,
        visible: 1,
        serverLogo: ""
      },
      isEdit: false,
      placeholder: "请输入url地址",
      serverSetTitle: "新增服务",
      okmessage: "保存成功!",
    	serverDetail: apiPath.server.serverDetail,
      checkboxItems: [],
      serverSetAction: "",
      beforeSubmit(val){
        
      },
      success:(res)=>{
        if (res.code === 0) {
          let path = this.official ? "/page/server/official-list" : "/page/server/third-party-list" 
          this.$route.router.go({
            path: path
          })
        } else {
          tip(res.error)
        }
      }
    }
	},
  
  route: {
    data(transition) {
      this.params.serviceId = transition.to.query.serviceId
      let getDetail = {}
      getDetail.serviceId = transition.to.query.serviceId
      this.official = transition.to.official
      let params = {}
      params.serviceType = this.official ? 1 : 2
      ajax(apiPath.server.getServerNum,{
        data: params,
        type: "GET"
      }).then((res) => {
        this.maxServerNum = res.data.serverNum + 1
        for(let i = 1; i <= this.maxServerNum; i++) {
          this.serverNumList.push({
            value: i,
            text: i
          })
        }
      })
      if(this.params.serviceId){
        this.isEdit = true
        ajax(apiPath.server.serverDetail,{
          data: getDetail,
          type: 'GET'
        }).then((res) => {
            this.params = Object.assign(this.params, res.data)
          }).catch((res) => {
            tip(res.message)
          })
      }else{
        this.isEdit = false
      }
      transition.next();
    },
    waitForData: true
  },
	methods: {
    save(){
      this.serverSetAction = this.isEdit ? apiPath.server.updateServer : (apiPath.server.addServer + "?serviceType=" + (this.official ? 1 : 2))
      // console.log(this.serverSetAction); 
      this.$refs.formArea.setAction(this.serverSetAction).submit()
    },
		deleteServer(){
      this.$refs.deleteServer.show();
    },
    deleteServerCb(){
      let deleteServer = {}
      deleteServer.serviceId = this.params.serviceId
      ajax(apiPath.server.deleteServer,{
          data: deleteServer,
          type: 'POST'
        }).then((res) => {
          tip("删除成功！")
          this.$refs.deleteServer.hide();
          let path = this.official ? "/page/server/official-list" : "/page/server/third-party-list" 
          this.$route.router.go({
            path: path
          })
      })
    }
	},
  
  store
}

module.exports = serverSet;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/server/server-set/server-set.js